import { Component } from '@angular/core';
import { CareFinitySession } from '../../../../services/CareFinitySession';
import { PatientImageViewType } from '../../../../../api/models';

@Component({
  selector: 'app-images-wrapper',
    templateUrl: './images-wrapper.component.html',
    styleUrls: ['./images-wrapper.component.css']
})
export class ImagesWrapperComponent {
    view:string;

    constructor() {
        this.view = CareFinitySession.practiceSettings?.patientImageViewType == PatientImageViewType.ListView ? "list" : "thumbnail";
    }

}
